module.exports = __webpack_public_path__ + "assets/logo-weclever-light.380e68ba.svg";